import ApiService from './api.service'
import { TokenService } from './storage.service'
import general from './../utils/general'
import posthog from 'posthog-js'

class AuthenticationError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const UserService = {
    /**
     * Login the user and store the access token to TokenService. 
     * 
     * @returns access_token
     * @throws AuthenticationError 
    **/
    login: async function(email, password, code) {
        
        let requestData = {
            method: 'post',
            url: "users/login",
            data: {
                email: email,
                password: password
            }
        }

        if ( typeof code !== 'undefined' ) {

            requestData.data.code = code;

        }

        try {

            const response = await ApiService.post(requestData.url,requestData.data);
            return this.processLoginInfo(response);

        } catch (error) {

            throw new AuthenticationError(error.response.status, error.response.data.error)

        }
    },

    processLoginInfo: function (response) {
        
        TokenService.saveToken(response.data.access_token)
        TokenService.saveId(response.data.uid)
        TokenService.saveAccountId(response.data.account)
        TokenService.saveInitials(response.data.initials)
        TokenService.saveName(response.data.name)
        TokenService.saveFirstName(response.data.firstName)
        if ( typeof response.data.sessionInfo !== 'undefined' ) TokenService.saveExtraInfo(response.data.sessionInfo)
        TokenService.saveRefreshToken(response.data.refresh_token)
        ApiService.setHeader()
        ApiService.mountInterceptor();
        general.globalMessage (response);
        if ( response.data.redirect ) {

            window.location.assign( response.data.redirect );

        }
        window.appziSettings = {
            userId: response.data.uid,
            data: {
              user: response.data.uid
            }
        };
        return response.data.access_token;

    },

    /**
     * Refresh the access token.
    **/
    refreshToken: async function() {
        const refreshToken = TokenService.getRefreshToken()
        const uid = TokenService.getId()
        const accountId = TokenService.getAccountId()
        const initials = TokenService.getInitials()
        const name = TokenService.getName()
        const requestData = {
            method: 'post',
            url: "users/refresh-token",
            data: {
                refreshToken: refreshToken,
                uid: uid,
                account: accountId,
                initials: initials,
                name: name
            }
        }

        try {
            const response = await ApiService.customRequest(requestData)

            TokenService.saveToken(response.data.access_token)
            TokenService.saveRefreshToken(response.data.refresh_token)
            // Update the header in ApiService
            ApiService.setHeader()

            return response.data.access_token
        } catch (error) { 
            throw new AuthenticationError(error.response.status, error.response.data.detail)
        }

    },

    /**
     * Logout the current user by removing the token from storage. 
     * 
     * Will also remove `Authorization Bearer <token>` header from future requests.
    **/
    logout() {
        // Remove the token and remove Authorization header from Api Service as well 
        TokenService.removeToken()
        TokenService.removeRefreshToken()
        TokenService.removeId()
        TokenService.removeInitials()
        TokenService.removeName()
        TokenService.removeFirstName()
        TokenService.removeAccountId()
        TokenService.removeSharedAccount()
        TokenService.removeExtraInfo()
        ApiService.removeHeader()
        ApiService.unmountInterceptor();
        if ( general.isDev() ) {

            posthog.reset();

        }
    }
}

export default UserService

export { UserService, AuthenticationError }